<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required ? 'label-blue' : '']"
    :rules="form.rules"
    :required="form.options.required"
    v-show="!form.options.hidden"
  >
    <el-upload
      ref="DynamicImg"
      :file-list="fileList"
      :headers="headers"
      :action="downUrl"
      :data="params"
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :auto-upload="true"
      :on-success="successHandle"
      :on-error="errorHandle"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-form-item>
</template>

<script>
import util from "@/libs/util.js";
export default {
  name: "DynamicImg",
  data() {
    return {
      fileList: [],
      headers: { userToken: util.session.get("token") },
      downUrl: this.$url.uploadimages,
      params: {
        path: "backend/maintenance/safety/w/images/",
      },
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          options: {
            defaultValue: [],
            width: "",
            tip: "只能上传jpg/png文件，且不超过500kb",
            action: "https://jsonplaceholder.typicode.com/photos/",
            customClass: "",
            disabled: false,
            limit: 9,
            fileList: [],
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
            remoteFunc: "func_1573098714232",
          },
          name: "文件",
          novalid: {},
          key: "1573098714232",
          model: "fileupload_1573098714232",
          rules: [],
        };
      },
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val;
      },
    },
  },
  methods: {
    successHandle(response, file, fileList) {
      let thant = this;
      if (response) {
        let vals = JSON.parse(response.data);
        if (
          thant.value[thant.form.model] == "" ||
          thant.value[thant.form.model] == null
        ) {
          this.value[this.form.model] = response.data;
        } else {
          let disVal = JSON.parse(this.value[this.form.model]);
          disVal.img += vals.img;
          disVal.video += vals.video;
          this.value[this.form.model] = JSON.stringify(disVal);
        }
        this.$emit("input", this.value, this.form.model);
      }
    },
    errorHandle(response, file, fileList) {},
    handleRemove(file, fileList) {
      // console.log(file);
      let thant = this;
      let removeImageURL = "";
      if (file.response) {
        let target = JSON.parse(file.response.data).img;
        let A = target.split(",")[0];
        removeImageURL = A;
      } else {
        let target = file.url.split("/");
        let A = `${target[target.length - 2]}/${target[target.length - 1]}`;
        removeImageURL = `dogdisk/root/backend/maintenance/safety/w/images/${A}`;
      }
      // console.log(removeImageURL);
      this.$http
        .post(thant.$url.deleteimages, { path: removeImageURL })
        .then((res) => {
          let disVal = JSON.parse(thant.value[thant.form.model]);
          // console.log(disVal);
          let disValList = disVal.img.split(",");
          // console.log(disValList);
          let newDisValList = disValList.filter((ele) => {
            return ele != removeImageURL;
          });
          // console.log(newDisValList);
          disVal.img = newDisValList.join(",");
          thant.value[thant.form.model] = JSON.stringify(disVal);
          thant.$emit("input", thant.value, thant.form.model);
          thant.$message({ message: "删除成功！", type: "success" });
        })
        .catch(() => {
          this.$message({ message: "删除失败,请重试！", type: "warning" });
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getUserToken() {
      let token = util.session.get("token");
      this.headers = {
        userToken: token,
      };
    },
    initFileList() {
      let listString = this.value[this.form.model];
      console.log(listString);
      if (listString) {
        let listObject = JSON.parse(listString).img;
        if (listObject) {
          let newFileList = [];
          let fileList = listObject.split(",");
          for (let item of fileList) {
            if (!item) continue;
            let itemSplit = item.split("/");
            newFileList = [
              ...newFileList,
              {
                name: itemSplit[itemSplit.length - 1],
                url: `http://117.157.231.103:5003/${item}`,
              },
            ];
          }

          this.fileList = newFileList;
        }
      } else {
        // this.$refs.DynamicImg.clearFiles();
        this.fileList = [];
      }
    },
  },
  created() {},
  mounted() {
    this.initFileList();
    // this.getUserToken();
  },
};
</script>

<style scoped></style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicImg.vue"
}
</vue-filename-injector>
